var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisabledLiveAuction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21434",
    "data-name": "\\uADF8\\uB8F9 21434",
    transform: "translate(-908 -359)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1159",
    "data-name": "\\uD0C0\\uC6D0 1159",
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(908 359)",
    fill: "#868e96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10140",
    "data-name": "\\uD328\\uC2A4 10140",
    d: "M0,44.975a2.533,2.533,0,0,1,.763-1.86,2.477,2.477,0,0,1,1.813-.763,2.533,2.533,0,0,1,1.86.763,2.534,2.534,0,0,1,.763,1.86,2.476,2.476,0,0,1-.763,1.813,2.532,2.532,0,0,1-1.86.763,2.476,2.476,0,0,1-1.813-.763A2.475,2.475,0,0,1,0,44.975m1.169-26a1.851,1.851,0,0,1,1.145-.5,1.807,1.807,0,0,1,1.169.406,2.579,2.579,0,0,1,.858,1.335V36.675a2.262,2.262,0,0,1-.62,1.6,1.888,1.888,0,0,1-1.264.572,1.856,1.856,0,0,1-1.288-.477,2.348,2.348,0,0,1-.739-1.55V20.361a2.428,2.428,0,0,1,.739-1.383",
    transform: "translate(933 353.523)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledLiveAuction);
export default __webpack_public_path__ + "static/media/DisabledLiveAuction.ff340c262bdd7775ca3bec21598b54ba.svg";
export { ForwardRef as ReactComponent };